<template>
	<div class="border-top">
		<SOFilterTitle title="Jenis Member" :diterapkan="filterItem.idmaster_member.length > 0" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputCheckbox :checkboxes="idmaster_member" @selected="selected" :checked="filterItem.idmaster_member"/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import conn from "@/store/utils/connection";
import jenisMemberAPi from "@/store/utils/api-route/jenisMemberApi";
export default {
	name: "SOFilterJenisMember",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
	},
	mounted() {
		this.getData();
	},
	data() {
		return {
			checked: [],
			idmaster_member: {
				name: "jenis-member",
				data: [
					// {
					// 	id: "fkontak-2",
					// 	value: "false",
					// 	title: "Tanpa nomor telpon",
					// 	checked: false,
					// 	titleBold: false,
					// },
				]
			},
		}
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.idmaster_member = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		async getData() {
			try {
				const res = await conn.get(jenisMemberAPi.listMemberLite)
				if (res.status === 200) {
					res.data.data.forEach((item, index) => {
						this.idmaster_member.data.push({
							id: "jenis-member-" + item.id,
							value: item.id,
							title: item.name,
							checked: false,
							titleBold: false,
						})
					})
				}
			} catch (error) {
				this.$toast.error(response.data.msg)
				console.log('error: ', error);
			}
		}
	}
}
</script>